import type { TaskSeriesView } from '@amumin/api-client';
import {
  repeatToInput,
  repeatToRule,
  summarizeRecurrenceIn,
  taskRecurrenceSummaryIn,
  type RepeatForm,
} from '@amumin/domain/recurrence';
import { recurrenceLangFor } from '@amumin/i18n';

// Herhaling-editor (DESIGN.md §8.W3, ONTWERP CAL-11/12/20/22): een klein formulier in gewone taal
// ("Elke week op di en do", "Om de week", "Elke laatste vrijdag") ↔ de RRULE-subset van de API.
// De NL-samenvatting komt uit @amumin/domain (dezelfde code als de server). Getest. Het formulier
// zelf (keuzes ↔ regel) staat in @amumin/domain/recurrence (form.ts), gedeeld met het bord.

export {
  defaultRepeat,
  nthOfMonth,
  repeatFromInput,
  repeatToInput,
  repeatToRule,
  sameRepeat,
  weekdayCode,
  type MonthlyMode,
  type Parity,
  type RepeatEnds,
  type RepeatForm,
  type RepeatKind,
} from '@amumin/domain/recurrence';

/**
 * Live samenvatting ("Elke dinsdag en donderdag om 18:30, 10 keer") in de taal van de app;
 * Nederlands is dezelfde tekst als de server.
 */
export function repeatSummary(
  form: RepeatForm,
  date: string,
  time: { allDay: boolean; start?: string | null; end?: string | null },
  locale?: string | null,
): string {
  const input = repeatToInput(form, date);
  const rule = repeatToRule(form, date);
  return summarizeRecurrenceIn(
    {
      rule,
      startDate: date,
      weekParity: input?.week_parity ?? null,
      count: input?.count ?? null,
      until: input?.until ?? null,
    },
    time.allDay ? { allDay: true } : { startTime: time.start ?? null, endTime: time.end ?? null },
    recurrenceLangFor(locale),
  );
}

/** Herhaling van een taak in de taal van de app; Nederlands = de tekst van de server. */
export function taskRecurrenceText(
  s: Pick<TaskSeriesView, 'recurrence' | 'start_date' | 'recurrence_summary_nl'>,
  locale: string | null | undefined,
): string {
  const lang = recurrenceLangFor(locale);
  const nl = s.recurrence_summary_nl;
  if (!lang) return nl ? nl.charAt(0).toUpperCase() + nl.slice(1) : '';
  const r = s.recurrence;
  return taskRecurrenceSummaryIn(
    r ? { ...r, interval: r.interval ?? 1 } : null,
    s.start_date,
    lang,
  );
}
